import React from "react";
import { Link } from "react-router-dom";
import "./deactivate-modal.style.scss";
export default function DeactivateModal({ closeIt }) {
  return (
    <div onClick={() => closeIt()} className="deactivate-modal-main">
      <div onClick={(e) => e.stopPropagation()} className="deactivate-modal">
        <header className="d-mod-header">
          <h5>Deactivate Account</h5>
          <img
            onClick={() => closeIt()}
            src="https://img.icons8.com/ios/250/000000/delete-sign--v1.png"
          />
        </header>
        <section className="d-mod-section">
          <div className="dms-wrapper">
            <h5>This will deactivate your account</h5>
            <p>
              You’re about to start the process of deactivating your AcadsHR
              account. Your display name, @username, and public profile will no
              longer be available on AcadsHR.com.
            </p>
            <h5>What else you should know</h5>
            <p>
              Your account will be temporarily disabled. You can reactivate
              anytime by logging in using your registered email address.
            </p>
            <p>
              Some account information may still be available in search engines,
              such as Google or Bing.
            </p>
          </div>
        </section>
        <footer className="d-mod-footer">
          <Link to="/user/deactivate">Continue</Link>
        </footer>
      </div>
    </div>
  );
}
